import script from "./NoticeRegardingTransactions.vue?vue&type=script&lang=ts&setup=true"
export * from "./NoticeRegardingTransactions.vue?vue&type=script&lang=ts&setup=true"

import "./NoticeRegardingTransactions.vue?vue&type=style&index=0&id=cba87310&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cba87310"]])

export default __exports__